/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Kosova <ivetta.kosova@opensoftdev.ru>
 */

define(['underscore', 'assets/js/common/router/index', 'assets/js/modules/AjaxOperation'], function(_, router, AjaxOperation) {
    var API_GET_CUSTOMERS = router.generate('/api/v0/get-customers/');

    return {
        getCustomers: function() {
            return new AjaxOperation(
                {
                    name: 'Get Customers'
                },
                {
                    type: 'get',

                    dataType: 'json',

                    url: API_GET_CUSTOMERS,

                    ajaxSuccess: function(data) {
                        if (typeof data == 'object') {
                            this.setFinished(AjaxOperation.SUCCESS, data);
                        } else {
                            this.setFinished(AjaxOperation.ERROR);
                        }
                    }
                }
            );
        }
    };
});
